import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';

@Component({
  selector: 'app-variable-benefit-lump-sum-payment-details-card',
  templateUrl: './variable-benefit-lump-sum-payment-details-card.component.html',
  styleUrls: ['./variable-benefit-lump-sum-payment-details-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VariableBenefitLumpSumPaymentDetailsCardComponent implements OnChanges {
  @Input() month!: number;
  @Input() year!: number;
  @Input() amount!: number;
  @Input() forgoRecurringPayments: boolean = false;

  public formattedMonthYear: string = '';
  public title: string = '';

  ngOnChanges(): void {
    this.title = this.forgoRecurringPayments ? $localize`Lump Sum Payment*` : $localize`Lump Sum Payment`;

    if (this.month && this.year) {
      const date = new Date(this.year, this.month - 1, 1);
      const monthName = date.toLocaleDateString('en-US', { month: 'long' });
      this.formattedMonthYear = `${monthName}, ${this.year}`;
    }
  }
}
